import Vue from 'vue';
import store from './store';
import router from './router';
import i18n from './i18n';
import vuetify from './vuetify';
import features from './mixins/features';
import { mpt } from './libs/monitoringPointText';
import { isUniversalLoginEnabled, isUniversalLoginCallback, receiveUniversalLogin } from './libs/universalLogin';
import './vue-config';
import './styles/main.sass';

// 将来的に Vue.mixin(features) で features を global mixin として全コンポーネントに
// 注入すれば、下記の .bind(this) が不要になり this.featureIsActive を直接渡せる。
// 副作用（全コンポーネントへの methods 注入）が許容できれば検討する。
// Vue.mixin(features);

Vue.prototype.$mpt = function $mpt(text) {
  return mpt(text, this.$i18n.locale, features.methods.featureIsActive.bind(this));
};

const startApplication = async function () {
  if (isUniversalLoginEnabled() && isUniversalLoginCallback(window.location.href)) {
    await receiveUniversalLogin({ store, router });
  } else if (store.getters.isSignedIn) {
    try {
      await store.dispatch('getUserInfo');
    } catch (error) {
      // TODO: Show logout reason
      store.dispatch('signOut');
    }
  }

  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    store,
    i18n,
    vuetify,
    render: h => h('router-view'),
  });
};

startApplication();
